import { getUserConfiguration } from 'owa-session-store';
import { updateUserConfigurationService } from 'owa-session-store/lib/services/updateUserConfigurationService';

export const VIEW_STATE_CONFIGURATION = 'OWA.ViewStateConfiguration';
/**
 * Updates search history in the user configuration.
 */
export default function updateSearchHistoryUserConfig(): void {
    const userConfiguration = getUserConfiguration();

    if (userConfiguration && userConfiguration.ViewStateConfiguration) {
        const { SearchHistory } = userConfiguration.ViewStateConfiguration;

        updateUserConfigurationService(
            [
                {
                    key: 'SearchHistory',
                    valuetype: 'StringArray',
                    value: SearchHistory,
                } as any,
            ],
            VIEW_STATE_CONFIGURATION
        );
    }
}
